// extracted by mini-css-extract-plugin
export default {"container":"PaymentMethod_container__gjJVH","flex":"PaymentMethod_flex__fYGd3"};